import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../_actions/loader.actions';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import ReactSwitch from 'react-switch';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';

const ManageNotificationRule = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [editdisabled, setEditDisabled] = useState(true);
    const [formValue, setFormValue] = useState(
        {
            NotificationTemplateId: 0,
            NotifiactionTypeId: 1,
            TemplateCode: '',
            ChannelMasterIds: [1],
            Title: "",
            Body: "",
            IsActive: false,
            UserId: 0
        }

    );
    const [dropdownList, setDropdownList] = useState([])
    const [formError, setFormError] = useState([]);

    //#region Validate Data
    const validateData = () => {
        let status = true;
        let error = {};
        if (formValue?.NotifiactionTypeId === 0) {
            error.NotifiactionTypeId = "Please select notification type.";
            status = false;
        }
        if (formValue?.Title?.trim()?.length <= 0) {
            error.Title = "Please provide Notification Title.";
            status = false;
        }
        if (formValue?.Body?.trim()?.length <= 0) {
            error.Body = "Please provide Notification Body.";
            status = false;
        }
        if (formValue?.ChannelMasterIds?.length === 0) {
            error.ChannelMasterIds = "Please select Channel.";
            status = false;
        }
        if (Object.keys(error)?.length > 0) {
            let id = Object.keys(error)[0];
            document.getElementById(id)?.focus();
        }
        setFormError(error)
        return status;
    }
    //#endregion

    //#region Add/Update Button Function
    const handleAddClick = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let user = GetLocalStorage();
                formValue.UserId = user?.userMasterID
                const res = await postUsersData("/master/v1/upsertnotificationtemplate", formValue);
                if (res?.status) {
                    handleClearClick();
                    dispatch({ type: 'ALERTINGMESSAGE', message: res.message })
                }
                else {
                    dispatch({ type: 'ALERTING', message: res.message })
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
            dispatch(loaderActions.end());
        }
    }
    //#endregion

    const getnotificationtemplateoptions = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const res = await getAllData("/master/v1/getnotificationtemplateoptions");
            if (res?.status) {
                const rownotificationChannel = res?.data?.notificationChannel || [];
                const notificationChannel = rownotificationChannel?.map((obj) => ({
                    label: obj?.ChannelName,
                    value: obj?.ChannelMasterId,
                }));
                const rownotificationType = res?.data?.notificationType || [];
                const notificationType = rownotificationType?.map((obj) => ({
                    label: obj?.NotificationTypeName,
                    value: obj?.NotificationTypeId,
                }));
                setDropdownList({ notificationChannel, notificationType });
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const getDataList = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const listdata = await getAllData("/master/v1/getnotificationtemplatelist");
            listdata?.data?.filter((el) => el.notificationTemplateId === location?.state?.id)?.map((obj) => {
                setFormValue((form) => ({
                    ...form,
                    NotificationTemplateId: obj?.notificationTemplateId ? obj?.notificationTemplateId : 0,
                    NotifiactionTypeId: obj?.notificationTypeId ? obj?.notificationTypeId : 0,
                    TemplateCode: obj?.templateCode ? obj?.templateCode : '',
                    ChannelMasterIds: obj?.channelMasterIds ? obj?.channelMasterIds : [],
                    Title: obj?.title ? obj?.title : "",
                    Body: obj?.body ? obj?.body : "",
                    IsActive: obj?.isActive
                }));
            })
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }


    //#region On Change Methods
    const onChange = (name, value) => {
        setFormError({})
        setEditDisabled(false);
        if (name === 'ChannelMasterIds') {
            setFormValue((form) => ({ ...form, [name]: value ? value?.map(val => val.value) : [] }))
        }
        else {
            setFormValue((form) => ({ ...form, [name]: value }))
        }
    };
    const handleisActive = (e) => {
        if (location?.state?.viewtype === 'Add') {
            setFormError({})
            setEditDisabled(false);
            setFormValue((form) => ({ ...form, IsActive: e }))
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (name, e) => {
        if (e === true) {
            setFormError({})
            setEditDisabled(false);
            if (name === "Active") {
                setFormValue((form) => ({ ...form, IsActive: !form?.IsActive }))
                setModalShow(false);
            }
        }
        else {
            setModalShow(false);
        }
    }
    //#endregion

    //#region handle clear operation
    const handleClearClick = () => {
        setFormError({})
        setFormValue((form) => ({
            ...form,
            NotificationTemplateId: 0,
            NotifiactionTypeId: 0,
            TemplateCode: '',
            ChannelMasterIds: [],
            Title: "",
            Body: "",
            IsActive: false
        }));
        setDisabled(false);
        setEditDisabled(true);
    }
    //#endregion
    useEffect(() => {
        getnotificationtemplateoptions();
    }, [])

    useEffect(() => {
        if (location?.state) {
            setDisabled(location?.state?.disabled);
            setEditDisabled(location?.state?.editdisabled);
            if (location?.state?.id > 0) {
                getDataList()
            }
        }
    }, [location?.state])
    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>Notification Template Manager</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Template ID</label>
                                        </div>
                                        <div className="col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                            <input
                                                type="text"
                                                id="TemplateCode"
                                                name="TemplateCode"
                                                className='form-control'
                                                defaultValue={formValue?.TemplateCode}
                                                disabled={true}
                                                placeholder="Template ID"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Notification Type</label>
                                        </div>
                                        <div className="col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                            <Select
                                                inputId='NotifiactionTypeId'
                                                className="dropdown select_dropdown"
                                                options={dropdownList?.notificationType}
                                                value={dropdownList?.notificationType?.filter((notificationType) => {
                                                    return notificationType.value === formValue.NotifiactionTypeId;
                                                })}// set list of the data
                                                onChange={(e) => onChange("NotifiactionTypeId", e?.value ? e?.value : 0)}  // assign onChange function
                                                isDisabled={disabled}
                                                isSearchable={true}
                                                isClearable
                                            />
                                            {formError?.NotifiactionTypeId && <p className="text-danger mb-0"> {formError?.NotifiactionTypeId} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Title/Subject</label>
                                        </div>
                                        <div className="col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                            <input
                                                type="text"
                                                id="Title"
                                                name="Title"
                                                className='form-control'
                                                value={formValue?.Title}
                                                onChange={(e) => { onChange("Title", e.target.value) }}
                                                disabled={disabled}
                                                maxLength={150}
                                                placeholder="Title/Subject"
                                            />
                                            {formError?.Title && <p className="text-danger mb-0"> {formError?.Title} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Body</label>
                                        </div>
                                        <div className="col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                            <input
                                                type="text"
                                                id="Body"
                                                name="Body"
                                                className='form-control'
                                                value={formValue?.Body}
                                                onChange={(e) => { onChange("Body", e.target.value) }}
                                                disabled={disabled}
                                                placeholder="Body"
                                                maxLength={250}
                                            />
                                            {formError?.Body && <p className="text-danger mb-0"> {formError?.Body} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Channel</label>
                                        </div>
                                        <div className="col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                            <Select
                                                isMulti
                                                inputId='ChannelMasterIds'
                                                className="dropdown select_dropdown"
                                                options={dropdownList?.notificationChannel}
                                                value={dropdownList?.notificationChannel?.filter((val) => formValue?.ChannelMasterIds?.includes(val.value)) || []}
                                                onChange={(e) => onChange('ChannelMasterIds', e)}
                                                isDisabled={disabled}
                                                isSearchable={true}
                                                isClearable
                                            />
                                            {formError?.ChannelMasterIds && <p className="text-danger mb-0"> {formError?.ChannelMasterIds} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div className='row align-items-center'>
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <label className="col-form-label">Active</label>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12" disabled={false}>
                                            <ReactSwitch
                                                onChange={handleisActive}
                                                checked={formValue?.IsActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation("Active", false)}
                                            yesconfirm={() => handleConfirmation("Active", true)}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? true : false}>{location?.state?.viewtype === "Add" ? 'Add' : 'Update'}</button>
                        <button type="button" class="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick} disabled={location?.state?.viewtype !== "Add" ? true : false} >Clear</button>
                        <button type="button" class="btn btn-primary mx-1" id="btnVisible" onClick={() => navigate("/NotificationTemplatelist")}>Back</button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default ManageNotificationRule